module.exports = __webpack_public_path__ + "img/bio-david-potts.a35c9f30.png";